/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { AFPTable } from '@gsa/afp-component-library';
import { emDashUnicode } from '../../../utilities/constants';
import { getVendorLink } from './contract-header-history-helpers';
import { ContractContext } from '../contract-provider';
import { getUSDateTimeStr } from '../components/contract-helpers';

export const Columns = [
  {
    Header: 'Version',
    accessor: 'versionNumber',
    sortable: true,
    Cell: ({ value }) => {
      const { maxVersionNumber } = useContext(ContractContext);
      const { contractHeaderId } = useParams();
      if (value === maxVersionNumber) {
        return (
          <RouterLink
            to={`/catalog/contract/contract-header/${contractHeaderId}`}
          >
            {value}
          </RouterLink>
        );
      }

      return (
        <RouterLink
          to={`/catalog/contract/contract-header/${contractHeaderId}/history/${value}`}
        >
          {value}
        </RouterLink>
      );
    },
  },
  {
    Header: 'Changed by',
    accessor: 'changedBy',
    sortable: true,
    Cell: ({ value }) => value,
  },
  {
    Header: 'Date/time of change',
    accessor: 'changedAt',
    sortable: true,
    Cell: ({ value }) => getUSDateTimeStr(value),
  },
  {
    Header: 'Number of changes',
    accessor: 'changeCount',
    sortable: false,
    Cell: ({ value }) => value || emDashUnicode,
  },
];

const ValueCell = ({ value, row: { original } }) => {
  if (original.fieldName !== 'Vendor') return value;
  return getVendorLink(value);
};
ValueCell.propTypes = {
  value: PropTypes.string.isRequired,
  row: PropTypes.shape({
    original: PropTypes.shape({
      fieldName: PropTypes.string,
      previousValue: PropTypes.string,
      currentValue: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export const RowSubComponent = ({ row: { original } }) => {
  const changeColumns = [
    {
      Header: 'Field name',
      accessor: 'fieldName',
      sortable: false,
    },
    {
      Header: 'Previous value',
      accessor: 'previousValue',
      sortable: false,
      Cell: ValueCell,
    },
    {
      Header: 'Current value',
      accessor: 'currentValue',
      sortable: false,
      Cell: ValueCell,
    },
  ];

  const updateColumns = [
    ...changeColumns,
    {
      Header: 'Updated by',
      accessor: 'updatedBy',
      sortable: false,
    },
    {
      Header: 'Updated at',
      accessor: 'updatedAt',
      sortable: false,
      Cell: ({ value }) => getUSDateTimeStr(value),
    },
  ];

  return (
    <section className="contract-history-table-subrow">
      <div className="title-s-caps text-primary margin-top-1">
        Contract version changes
      </div>
      {original.changes.length > 0 ? (
        <div className="contract-version-changes-table">
          <AFPTable data={original.changes} columns={changeColumns} />
        </div>
      ) : (
        <div className="margin-left-2 margin-top-1">{emDashUnicode}</div>
      )}
      {original.updates.length > 0 && (
        <>
          <div className="title-s-caps text-primary margin-top-4">
            Other contract updates
          </div>
          <AFPTable data={original.updates} columns={updateColumns} />
        </>
      )}
    </section>
  );
};

RowSubComponent.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      changeCount: PropTypes.number.isRequired,
      changes: PropTypes.arrayOf(
        PropTypes.shape({
          fieldName: PropTypes.string,
          previousValue: PropTypes.string,
          currentValue: PropTypes.string,
        }).isRequired,
      ),
      updates: PropTypes.arrayOf(
        PropTypes.shape({
          fieldName: PropTypes.string,
          previousValue: PropTypes.string,
          currentValue: PropTypes.string,
          updatedBy: PropTypes.string,
          updatedByEmail: PropTypes.string,
          updatedAt: PropTypes.string,
        }).isRequired,
      ),
    }),
  }).isRequired,
};
